// extracted by mini-css-extract-plugin
module.exports = {"title":"YU90c","subtitle":"sg5VL"};